import {
    FORCE_DISPLAY_UNENRICHED_REPORT_TYPES,
    GRID_HEADER_HEIGHT,
    GRID_MARGIN_HEIGHT,
    GRID_COLS,
    GRID_MARGIN_WIDTH,
    GRID_WIDTH_OFFSPACE,
} from './consts';

export const getWidgetsHeight = widgets => Math.max(...widgets.map(w => w.gridParams.y + w.gridParams.h));
export const getEntireGridHeight = (widgets, rowHeight) => getWidgetsHeight(widgets) * (rowHeight + GRID_MARGIN_HEIGHT);
export const calculateGridWidgetHeight = (widgetHeight, rowHeight) =>
    (rowHeight + GRID_MARGIN_HEIGHT) * widgetHeight - GRID_MARGIN_HEIGHT - GRID_HEADER_HEIGHT;
export const calculateGridWidgetWidth = (widgetWidth, gridWidth) => {
    const effectiveGridWidth = gridWidth - GRID_WIDTH_OFFSPACE;
    const columnWidth = (effectiveGridWidth - (GRID_COLS + 1) * GRID_MARGIN_WIDTH) / GRID_COLS;
    return (columnWidth + GRID_MARGIN_WIDTH) * widgetWidth - GRID_MARGIN_WIDTH;
};

export const shouldDisplayUnenriched = (userDisplayUnenriched, quickReportType) =>
    userDisplayUnenriched || FORCE_DISPLAY_UNENRICHED_REPORT_TYPES.includes(quickReportType);
